module.exports = __webpack_public_path__ + "static/media/undraw-workout-gcgu.5c07704e.svg";